import { TmApiAccessError } from '@/core/error/transport/tmApiAccessError'

export class TmPaidServicesDisabledError extends TmApiAccessError {
  public name = 'TmPaidServicesDisabledError'
}
